Vue.component('temporary-cards', {
    template: templates.temporaryCards,
    data() {
      return {
        model: {
          edit: false,
          card: {
            active: false,
            name: null,
            hp: 0,
            pAtk: 0,
            mAtk: 0,
            armor: 0,
            ward: 0,
            accuracy: 0,
            speed: 0,
            critChance: 0,
            critDamage: 150,
            stamina: 1,
            mana: 1,
            type: null,
            ability: null,
            trait: null,
            ultimate: 0,
            active: false,
            image: null,
            tier: 0
          },
          cards: {
            
          },
          types: {
            
          },
          tiers: {
            '1': {
              name: 'Standard'
            },
            '2': {
              name: 'Ultra'
            },
            '3': {
              name: 'Legendary'
            }
          },
          abilities: {

          },
          traits: []
        }
      }
    },
    watch: {
      'model.card.image': function(newImage) {
        this.refreshImage(); 
      }
    },
    mounted() {
      const c = this;
      c.get();

      c.$root.$on('remove-existing-image', data => {

        c.removeCurrentFile(data);
      })
  
    },
    methods: {
      get() {
        const c = this;
        let data = {};
  
        cardService.getEventCards()
          .then(function (response) {
       
            for (let d of response.data) {
              d.image = [`${d.id}.png?t=${Date.now()}`];
              data[`${d.id}`] = d;
            }
            c.model.cards = data;
            
            c.getTypes();
            c.getAbilities();
            c.getTraits();
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      getTypes() {
        const c = this;
        let data = {};
  
        typeService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.types = data;
            // c.$root.$emit('types', data);
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      getAbilities() {
        const c = this;
        let data = {};

        abilityService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.abilities = data;
            // c.$root.$emit('abilities', data);
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      getTraits() {
        const c = this;

        traitService.get()
          .then(function (response) {
            c.model.traits = response.data;
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      edit(id) {
        const c = this;
        let data = c.model.cards[`${id}`];
  
        if (id == c.model.card.id) {
          c.model.edit = false;
        } else {
          c.model.edit = true;
        }
  
        c.model.card = {
          active: data.active,
          id: id,
          name: data.name,
          hp: data.hp,
          pAtk: data.pAtk,
          mAtk: data.mAtk,
          armor: data.armor,
          ward: data.ward,
          accuracy: data.accuracy,
          speed: data.speed,
          critChance: data.critChance,
          critDamage: data.critDamage,
          stamina: data.stamina,
          mana: data.mana,
          type: data.type,
          ability: data.ability,
          trait: data.trait,
          ultimate: data.ultimate,
          image: data.image,
          tier: data.tier,
          baseCardId: data.baseCardId,
          is_modified_existing: data.is_modified_existing
        }
        
      },
      add() {
        const c = this;
        c.model.edit = true;
      },
      save() {
        const c = this;
        const data = c.model.card;
  
        if (!data.name) {
          utils.alert.error('Name is required');
          return;
        }
  
        if (data.active && (data.hp == 0 || data.accuracy == 0 || data.speed == 0)) {
          utils.alert.error('HP, Speed and Accuracy are required to activate a card.');
          return;
        }
        
        cardService.eventSave(data)
          .then(function (response) {
  
            if (data.id) {
              c.model.cards[`${data.id}`] = data;
            } else {
              data.id = response.data.id;
              c.model.cards[`${data.id}`] = data;
            }
  
            // c.reset();
  
            utils.alert.success('Saved!');
            
          })
          .catch(function (error) {
            utils.alert.error('Failed to save.');
          });
      },
      reset() {
        const c = this;
        c.model.edit = false;
  
        c.model.card = {
          name: null,
          hp: 0,
          pAtk: 0,
          mAtk: 0,
          armor: 0,
          ward: 0,
          accuracy: 0,
          speed: 0,
          critChance: 0,
          critDamage: 150,
          stamina: 1,
          mana: 1,
          type: null,
          ability: null,
          trait: null,
          ultimate: 0,
          active: false
        }
      },
      handleCardImageUpload(data) {
        const c = this;
        if (data && data.files && data.files.length > 0) {
          const newImage = [`${c.model.card.id}.png?t=${Date.now()}`];
          Vue.set(c.model.card, 'image', newImage);
          if (c.model.cards[`${c.model.card.id}`]) {
            Vue.set(c.model.cards[`${c.model.card.id}`], 'image', newImage);
          }
          utils.alert.success('Image uploaded!');
          c.$forceUpdate();
          c.get();
        }
      },
      refreshImage() {
        const c = this;
        const imageUrl = `${c.getCardUrl()}${c.model.card.image}`;
        
        c.checkImageExists(imageUrl).then(exists => {
          if (!exists) {
            c.model.card.image = null; 
            c.model.cards[`${c.model.card.id}`].image = null
          }
        });
      },
      checkImageExists(url) {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = url;
          img.onload = () => resolve(true);
          img.onerror = () => resolve(false);
        });
      },
      getCardUrl(){
        const c = this;
        const url = `${root}/images/temp_cards/`;
        return url;
        
      },
      removeCurrentFile(data){
        const c = this;
  
        const id = c.model.card.id
        uploadService.deleteFile('cards', id, data.image)
        .then(function (response) {
  
          c.model.card.image = null;
          utils.alert.success('File Removed!');
        })
        .catch(function (error) {
          utils.alert.error(error);
        });
      },
    }
  });